import { render, staticRenderFns } from "./ReturnShippingFee.vue?vue&type=template&id=4d3c69f8&"
import script from "./ReturnShippingFee.vue?vue&type=script&lang=ts&"
export * from "./ReturnShippingFee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports